import React from 'react';
import { ButtonComp } from 'atoms/Buttons';

/**
 *
 * @param {*} props - props for the Header Track Order item
 *
 */
const HeaderTrackOrderItems = props => {
  const { buttonText = '', trackOrderTitle = '', ariaLabel = '', onTrackOrderBtnClickHandler = null } = props;
  return (
    <div className='headerTrackOrderPanel col-12' data-testid='header-track-order-items'>
      <div className='headBottomParent col-12'>
        <div className='head-track-order-Txt'>
          <span>{trackOrderTitle}</span>
        </div>
        <div className='header-track-order-btn'>
          <ButtonComp
            data-testid='header-Track-order-button'
            className='button'
            aria-label={ariaLabel || buttonText}
            onClickHandler={onTrackOrderBtnClickHandler}
            id='headerTrackOrderItemButton'
            type='submit'
          >
            <span>{buttonText}</span>
          </ButtonComp>
        </div>
      </div>
    </div>
  );
};

export default React.memo(HeaderTrackOrderItems);
